__turbopack_context__.v({
  "colL": "SavedSearchForm-module__fvHYfa__colL",
  "colR": "SavedSearchForm-module__fvHYfa__colR",
  "ctaSection": "SavedSearchForm-module__fvHYfa__ctaSection",
  "disclaimer": "SavedSearchForm-module__fvHYfa__disclaimer",
  "filterCtaWrapper": "SavedSearchForm-module__fvHYfa__filterCtaWrapper",
  "formSubmitted": "SavedSearchForm-module__fvHYfa__formSubmitted",
  "formTitle": "SavedSearchForm-module__fvHYfa__formTitle",
  "modalContainer": "SavedSearchForm-module__fvHYfa__modalContainer",
  "noPadding": "SavedSearchForm-module__fvHYfa__noPadding",
  "pageBellButtonWrapper": "SavedSearchForm-module__fvHYfa__pageBellButtonWrapper",
  "pageCtaWrapper": "SavedSearchForm-module__fvHYfa__pageCtaWrapper",
  "title": "SavedSearchForm-module__fvHYfa__title",
  "wrapper": "SavedSearchForm-module__fvHYfa__wrapper",
});
